<div class="unified-registration-container">
  <div class="unified-registration-header" [ngClass]="{'centered-logo': !showLoginButton}">
    <a href="/">
      <img src="/utest-static/assets/images/utestLogoWhite-reg.svg" alt="uTest" />
    </a>
    @if (showLoginButton) {
      <div class="login-link-container">
        <span class="have-account-text">Have An Account?</span>
        &ngsp;<a [href]="getLoginUrl()" class="login-link" target="_self">Log In</a>
      </div>
    }
  </div>

  <div class="unified-registration-content">
    <div ui-view></div>
  </div>

  <!-- Footer -->
  <footer class="unified-registration-footer">
    <div class="footer-content">
      <div class="footer-logo">
        <a href="/">
          <img src="/utest-static/assets/images/uTestLogoNav.svg" alt="uTest" class="footer-logo-img" />
        </a>
      </div>
      <div class="social-links">
        <span class="follow-text">Follow Us On Social</span>
        <div class="social-icons">
          <a href="https://x.com/utest" target="_blank" class="social-icon" aria-label="Twitter">
            <img src="/utest-static/assets/images/social/registration/x.svg" alt="Twitter" />
          </a>
          <a href="https://www.instagram.com/utestinc/" target="_blank" class="social-icon" aria-label="Instagram">
            <img src="/utest-static/assets/images/social/registration/instagram.svg" alt="Instagram" />
          </a>
          <a href="https://www.facebook.com/utest" target="_blank" class="social-icon" aria-label="Facebook">
            <img src="/utest-static/assets/images/social/registration/facebook.svg" alt="Facebook" />
          </a>
          <a href="https://www.linkedin.com/company/utest" target="_blank" class="social-icon" aria-label="LinkedIn">
            <img src="/utest-static/assets/images/social/registration/linkedin.svg" alt="LinkedIn" />
          </a>
          <a href="https://www.reddit.com/r/UTEST/" target="_blank" class="social-icon" aria-label="Reddit">
            <img src="/utest-static/assets/images/social/registration/reddit.svg" alt="Reddit" />
          </a>
        </div>
      </div>
    </div>
    <div class="footer-bottom">
      <div class="copyright">© {{ currentYear }} Applause App Quality, Inc.</div>
      <div class="footer-links">
        <a href="/terms-of-use" target="_blank" rel="noopener noreferrer">Terms of Use</a>
        &ngsp;<a href="/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
        &ngsp;<a href="/ai-guidelines" target="_blank" rel="noopener noreferrer">AI Guidelines</a>
        &ngsp;<button class="ot-sdk-show-settings" id="ot-sdk-btn">Cookie Settings</button>
        &ngsp;<a href="/phishing-notice" target="_blank" rel="noopener noreferrer">Phishing Notice</a>
        &ngsp;<a href="https://support.utest.com/csp" target="_blank" rel="noopener noreferrer">Help & Support</a>
      </div>
    </div>
  </footer>
</div>
